export default __webpack_public_path__ + "static/media/smiley.52d75709.png";